import React from 'react'
import { getCustomImage, parseMsToISO, videoDurationStringToMs } from '../helpers'
import { stripHtml, stripNull } from '../../api/helpers'
import StructuredData from './StructuredData'

export const getVideoObjectData = (data) => {
  const { video = {}, title = '', description, conferenceYear = null, url = null } = data
  const videoUploadDate = conferenceYear ? new Date(`${conferenceYear}-02-23T00:00:00Z`).toISOString() : null
  const videoDuration = video?.videoDuration ? parseMsToISO(videoDurationStringToMs(video.videoDuration)) : null

  return {
    '@type': 'VideoObject',
    name: title,
    description: stripNull(stripHtml(description)),
    thumbnailUrl: getCustomImage(data),
    uploadDate: videoUploadDate,
    duration: videoDuration,
    contentUrl: url,
    // TODO: Consider creating an /embed/session-title page and route to allow this.
    // embedUrl: video.videoProvider?.videoId ? `https://www.youtube.com/watch
    // interactionStatistic: {
    //   '@type': 'InteractionCounter',
    //   interactionType: 'https://schema.org/WatchAction',
    //   userInteractionCount: session.viewCount || 0,
    // },
  }
}
// const getVideoObjectData = (session) => {
//   return {
//     '@type': 'VideoObject',
//     name: session.title,
//     description: session.description,
//     thumbnailUrl: getCustomImage(session),
//     // uploadDate: session.uploadDate,
//     duration: session.duration ? `PT${session.duration}S` : undefined,
//     contentUrl: session.url,
//   }
// }
// const getVideoObjectData = (video, data) => {
//   if (!video.url) return undefined
//   return {
//     '@type': 'VideoObject',
//     name: video.headline || 'Video',
//     description: data.description?.replace(/<br\s*\/?>/g, '\n') || 'No description available',
//     thumbnailUrl: video.thumbnail?.attribute?.publicUrl || '',
//     contentUrl: video.url,
//     uploadDate: data.date || (data.conferenceYear ? data.conferenceYear : ''),
//     duration: video.videoDuration ? formatDuration(video.videoDuration) : '',
//     // embedUrl: video.videoProvider?.videoId ? `https://www.youtube.com/watch?v=${video.videoProvider.videoId}` : '',
//   }
// }

export default function VideoObjectStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0 || !data.video) return null
  const structuredData = getVideoObjectData(data)

  return <StructuredData data={structuredData} dataTestId="video-object-structured-data" />
}
